import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15 7.06984C15 6.39984 14.67 5.77984 14.11 5.40984L10.11 2.73984C9.44 2.28984 8.56 2.28984 7.89 2.73984L3.89 5.40984C3.34 5.77984 3 6.39984 3 7.06984V12.7498C3 13.0298 3.22 13.2498 3.5 13.2498H14.5C14.78 13.2498 15 13.0298 15 12.7498V7.06984ZM9 10.7498C8.04 10.7498 7.25 9.95984 7.25 8.99984C7.25 8.03984 8.04 7.24984 9 7.24984C9.96 7.24984 10.75 8.03984 10.75 8.99984C10.75 9.95984 9.96 10.7498 9 10.7498Z",
  fill: "#292E36"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 21.2501H20.73V18.2501C21.68 17.9401 22.37 17.0501 22.37 16.0001V14.0001C22.37 12.6901 21.3 11.6201 19.99 11.6201C18.68 11.6201 17.61 12.6901 17.61 14.0001V16.0001C17.61 17.0401 18.29 17.9201 19.22 18.2401V21.2501H15V15.2501C15 14.9701 14.78 14.7501 14.5 14.7501H3.5C3.22 14.7501 3 14.9701 3 15.2501V21.2501H2C1.59 21.2501 1.25 21.5901 1.25 22.0001C1.25 22.4101 1.59 22.7501 2 22.7501H19.93C19.95 22.7501 19.96 22.7601 19.98 22.7601C20 22.7601 20.01 22.7501 20.03 22.7501H22C22.41 22.7501 22.75 22.4101 22.75 22.0001C22.75 21.5901 22.41 21.2501 22 21.2501ZM8.25 18.2501C8.25 17.8401 8.59 17.5001 9 17.5001C9.41 17.5001 9.75 17.8401 9.75 18.2501V21.2501H8.25V18.2501Z",
  fill: "#292E36"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdressIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})